import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 1F0D9425-0B92-46C6-AEBE-39FB5E062AA5
 * name tally-mark-1
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tally-mark-1.svg
 * tags
 * - Math 
 */
export const TallyMark1Icon = createSvgIcon(<><path d="M13 19H11V5H13V19Z" /></>, 'TallyMark1Icon');
export default TallyMark1Icon